import { render, staticRenderFns } from "./UnitOccupancyListItemNew.vue?vue&type=template&id=cf944824&scoped=true&"
import script from "./UnitOccupancyListItemNew.vue?vue&type=script&lang=js&"
export * from "./UnitOccupancyListItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf944824",
  null
  
)

export default component.exports